import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUserPreferences } from '../contexts/UserPreferencesContext';

interface BudgetStatusProps {
  status: 'unallocated' | 'underfunded' | 'balanced';
  unallocated_amount?: number;
  underfunded_amount?: number;
}

export const BudgetStatus: React.FC<BudgetStatusProps> = ({
  status,
  unallocated_amount = 0,
  underfunded_amount = 0,
}) => {
  const { t } = useTranslation();
  const { formatMoney } = useUserPreferences();
  // Only show if not balanced
  if (status === 'balanced') {
    return null;
  }

  const isUnderfunded = status === 'underfunded';
  const fundDifference = isUnderfunded ? underfunded_amount : unallocated_amount;

  return (
    <div
      className={`p-4 border-4 font-mono ${isUnderfunded
        ? 'bg-[#ffebee] border-[#c62828]'
        : 'bg-[#e3f2fd] border-[#1565c0]'
        }`}
      style={{ boxShadow: '4px 4px 0 ' + (isUnderfunded ? '#c62828' : '#1565c0') }}
    >
      <p
        className={`text-sm font-bold uppercase ${isUnderfunded ? 'text-[#c62828]' : 'text-[#1565c0]'
          }`}
        style={{ fontFamily: "'Press Start 2P', monospace", fontSize: '10px', lineHeight: '1.6' }}
      >
        {isUnderfunded
          ? `${t('budget_status.underfunded')} ${formatMoney(Math.abs(fundDifference))}`
          : `${t('budget_status.ready_to_allocate')} ${formatMoney(fundDifference)}`}
      </p>
    </div>
  );
};
